module.exports = __webpack_public_path__ + "img/9c120258936b72aa5a4ee68e12300b96.a4496690.jpg";